import { useIntl } from '@edx/frontend-platform/i18n';
import StaticPageLayout from './StaticPageLayout';
import { getAboutPageContent } from './content';

const AboutPage = () => {
  const intl = useIntl();

  return <StaticPageLayout {...getAboutPageContent(intl)} />;
};

export default AboutPage;
